export default "__VITE_ASSET__Cn8zDJwI__"